import { MemberDesignersLicenseItemArray } from "app/models/ss-api/responses/member.designers.license.item";

export interface IMemberDesignersLicensesBasicsResponse {

    Keys: MemberDesignersLicenseItemArray;
    Name: string;
    Email: string;
    Phone: string;
    Credit: number;

}

export class MemberDesignersLicensesBasicsResponse implements IMemberDesignersLicensesBasicsResponse {

    Keys: MemberDesignersLicenseItemArray;
    Name: string;
    Email: string;
    Phone: string;
    Credit: number;

}

export class MemberDesignerLicenseBasicsResponseArray extends Array<MemberDesignersLicensesBasicsResponse> {

    constructor(...items: MemberDesignersLicensesBasicsResponse[]) {
        super(...items);
        Object.setPrototypeOf(this, MemberDesignerLicenseBasicsResponseArray.prototype);
    }

}